import { useConfigStore } from "@/store/config";

export const API_URL = process.env.VUE_APP_API_URL;

export default {

    async uniExec(data) {  

            const configStore  = useConfigStore();

            const fullName = `${configStore.userFirstName || ''} ${configStore.userLastName || ''}`.trim();

            const enrichedData = {
                ...data,
                User: fullName || "Nieznany użytkownik"
            };
            
            const headers = { ...configStore.authHeader };
        
            const requestOptions = {
                  method: "POST",
                  headers: headers,
                  body: JSON.stringify(enrichedData)
            };

            const response = await fetch(API_URL + "api/admin/execute", requestOptions);
            let responseData = await response.json();

            if (typeof responseData === "string") {
                responseData = JSON.parse(responseData);
            }
            
            return {
                  'status': response.status,
                  'data': responseData
            };
    },  
    
    async uploadAsset(formData) {
        const configStore = useConfigStore();
        const headers = { ...configStore.authOnly };
        const response = await fetch(API_URL + "api/admin/assets", {
            method: "POST",
            headers: headers,
            body: formData
        });
        return response.json();
    },

    async deleteAsset(id) {
        const configStore = useConfigStore();
        const headers = { ...configStore.authOnly };
        const response = await fetch(API_URL + "api/admin/assets/" + id, {
            method: "DELETE",
            headers: headers
        });
        return response.json();
    }

}